import React, { useEffect, useState } from "react";
import "./CategoryTopicItems.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { categoryOptions, spinContent } from "../../../services/customData";
import { Button, Modal, Spin, Form, message } from "antd";
import { FormMultiSelect } from "../../FormInputs/FormSelect";
import { FormRadioGroup } from "../../FormInputs/FormRadio";
import { postApi } from "../../../utils/apiServices";
import {
  ADD_TOPIC_ITEM,
  DELETE_TOPIC_ITEM,
  GET_CATEGORIES_LIST,
  GET_TOPIC_ITEMS,
} from "../../../utils/apiPath";
import { IMAGE_BASE_PATH } from "../../../utils/constant";
import { CloseOutlined } from "@ant-design/icons";
import ToastHelper from "../../../services/ToastHelper";

const CategoryTopicItems = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const topicData = location.state.topicData;
  const [form] = Form.useForm();

  const [categoryTopics, setCategoryTopics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryOption, setCategoryOption] = useState(null);
  const [categoryList1, setCategoryList1] = useState([]);
  const [categoryList2, setCategoryList2] = useState([]);
  const [categoryList3, setCategoryList3] = useState([]);
  const [open, setOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [categoryFilterList, setCategoryFilterList] = useState([]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const preparePayload = (values) => {
    const payload = values?.map((id) => ({
      topicType: topicData?.topicType,
      topicId: topicData?.topicId,
      itemId: id,
      topicMediaId: null,
    }));

    return payload;
  };

  const handleOk = async () => {
    setLoading(true);
    try {
      await form.validateFields();
      const values = form.getFieldsValue();

      let selectedIds = [];

      if (categoryOption === 1) {
        selectedIds = values.categoryLayer1 || [];
      } else if (categoryOption === 2) {
        selectedIds = values.categoryLayer2 || [];
      } else if (categoryOption === 3) {
        selectedIds = values.categoryLayer3 || [];
      }

      const payload = preparePayload(selectedIds);
      const res = await postApi(`${ADD_TOPIC_ITEM}`, payload);
      setLoading(false);
      message.success("Category topic items added successfully");
      form.resetFields();
      setCategoryOption(null);
      setIsModalOpen(false);
      getTopicItems();
    } catch (error) {
      console.error("Validation Error:", error);
    }
  };

  const handleCancel = () => {
    setCategoryOption(null);
    form.resetFields();
    setIsModalOpen(false);
  };

  const handleBack = () => {
    navigate("/manage-topics");
  };

  const handleBack1 = () => {
    const data = {
      ...topicData,
      title: topicData?.name,
    };
    navigate(`/manage-topics/advertisement/${topicData?.topicId}`, {
      state: { topicData: data },
    });
  };

  useEffect(() => {
    getTopicItems();
  }, []);

  const getTopicItems = async () => {
    setLoading(true);
    const payload = {
      topicId: topicData?.topicId,
      topicType: topicData?.topicType,
      topicMediaId: topicData?.topicMediaId || null,
    };
    try {
      const res = await postApi(`${GET_TOPIC_ITEMS}`, payload);
      setCategoryTopics(res?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching topic items", error);
    }
  };

  useEffect(() => {
    if (categoryOption) {
      const topicIds = categoryTopics?.map((item) => item?.itemId);
      if (categoryOption === 1) {
        setCategoryFilterList(categoryList1?.filter((item) => !topicIds.includes(item.value)
        ));
      } else if (categoryOption === 2) {
        setCategoryFilterList(categoryList2?.filter((item) => !topicIds.includes(item.value))
        );
      } else {
        setCategoryFilterList(categoryList3?.filter((item) => !topicIds.includes(item.value))
        );
      }
    }
  }, [categoryTopics, categoryOption, categoryList1, categoryList2, categoryList3]);

  const fetchCategories = async (parentId = 0) => {
    const payload = {
      pageIndex: 0,
      pageSize: 100,
      searchString: "",
      parentCategoryId: parentId,
    };
    try {
      const res = await postApi(`${GET_CATEGORIES_LIST}`, payload);
      return res?.data || [];
    } catch (error) {
      console.error("Error fetching categories", error);
      return [];
    }
  };

  useEffect(() => {
    (async () => {
      const options = await fetchCategories();
      setCategoryList1(
        options?.map((item) => ({ label: item.title, value: item.id }))
      );
    })();
  }, []);

  const handleLayer1Change = async (value) => {
    form.setFieldsValue({ categoryLayer2Id: null, categoryLayer3Id: null });
    const options = await fetchCategories(value);
    setCategoryList2(
      options?.map((item) => ({ label: item.title, value: item.id }))
    );
    setCategoryList3([]);
  };

  const handleLayer2Change = async (value) => {
    form.setFieldsValue({ categoryLayer3Id: null });
    const options = await fetchCategories(value);
    setCategoryList3(
      options?.map((item) => ({ label: item.title, value: item.id }))
    );
  };

  const handleValuesChange = (changedValues, allValues) => {
    if ("categoryOption" in changedValues) {
      setCategoryOption(changedValues.categoryOption);
      form.setFieldsValue({
        categoryLayer1: null,
        categoryLayer2: null,
        categoryLayer3: null,
      });
    }
  };

  const handleDeleteModal = (item) => {
    setDeleteItem(item);
    setOpen(true);
  };

  const handleClose = () => {
    setDeleteItem(null);
    setOpen(false);
  };

  const handleDeleteTopicItem = async () => {
    try {
      const payload = {
        itemId: deleteItem?.itemId,
        topicId: topicData?.topicId,
        topicType: topicData?.topicType,
        topicMediaId: null,
      };
      const res = await postApi(`${DELETE_TOPIC_ITEM}`, payload);

      if (res?.statusCode === 200) {
        ToastHelper.success("Category topic deleted successfully");
        handleClose();
        getTopicItems();
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="category-topic">
      <div className="category-topic_container">
        <div className="category-topic_header">
          <div className="category-topic_header_left">
            <h2>Category Topic</h2>
            <div className="category-topic_header_left_links">
              <span onClick={handleBack}>Topics</span>
              {topicData?.name && (
                <span onClick={handleBack1}> / {topicData?.name}</span>
              )}
              <span className="active"> / {topicData?.title}</span>
            </div>
          </div>
          {!topicData?.name && (
            <div className="category-topic_header_right">
              <Button type="primary" onClick={showModal}>
                Add
              </Button>
            </div>
          )}
        </div>
        <div className="category-topic_sections">
          <div className="category-topic_cards">
            {categoryTopics?.length > 0 &&
              categoryTopics?.map((topic, index) => {
                return (
                  <div key={index} className="category-topic_card">
                    <div className="category-topic_card_image">
                      <img
                        src={`${IMAGE_BASE_PATH}${topic?.itemImage}`}
                        alt=""
                      />
                      <div
                        className="category-topic_card_close"
                        onClick={() => handleDeleteModal(topic)}
                      >
                        <CloseOutlined />
                      </div>
                    </div>
                    <div className="category-topic_card_content">
                      <h3>{topic?.itemName}</h3>
                    </div>
                  </div>
                );
              })}
          </div>
          {loading ? (
            <div className="category-topic_loading">
              <Spin tip="Loading">{spinContent}</Spin>
            </div>
          ) : (
            categoryTopics?.length === 0 && <h5>No category topic available</h5>
          )}
        </div>
      </div>
      <Modal
        title="Add"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered={true}
        maskClosable={false}
      >
        <div className="category-topic_modal">
          <Form
            form={form}
            layout="vertical"
            onValuesChange={handleValuesChange}
          >
            <FormRadioGroup
              label="Select the category option"
              name="categoryOption"
              rules={[
                {
                  required: true,
                  message: "Please select an category option",
                },
              ]}
              options={categoryOptions}
            />
            {categoryOption && (
              <FormMultiSelect
                label="Select category layer1"
                name="categoryLayer1"
                placeholder="Select category layer1"
                rules={[{ required: true }]}
                options={categoryOption === 1 ? categoryFilterList : categoryList1}
                mode={categoryOption === 1 && "multiple"}
                onChange={categoryOption === 1 ? null : handleLayer1Change}
              />
            )}
            {(categoryOption === 2 || categoryOption === 3) && (
              <FormMultiSelect
                label="Select category layer2"
                name="categoryLayer2"
                placeholder="Select category layer2"
                rules={[{ required: true }]}
                options={categoryOption === 2 ? categoryFilterList : categoryList2}
                mode={categoryOption === 2 && "multiple"}
                onChange={categoryOption !== 3 ? null : handleLayer2Change}
              />
            )}
            {categoryOption === 3 && (
              <FormMultiSelect
                label="Select category layer3"
                name="categoryLayer3"
                placeholder="Select category layer3"
                rules={[{ required: true }]}
                options={categoryOption === 3 ? categoryFilterList : categoryList3}
                mode={categoryOption === 3 && "multiple"}
              />
            )}
          </Form>
        </div>
      </Modal>
      <Modal
        title="Confirm"
        open={open}
        onOk={handleDeleteTopicItem}
        onCancel={handleClose}
        width={300}
      >
        <p>Are you sure want to delete?</p>
      </Modal>
    </div>
  );
};

export default CategoryTopicItems;
